import { useEffect } from 'react';

const SUFFIX = 'Rudder Lookout';

export function usePageTitle(title?: string | null): void {
  useEffect(() => {
    document.title = title ? `${title} — ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = SUFFIX;
    };
  }, [title]);
}
